import { useState } from 'react';

export const useDeletePopup = () => {
    const [showDeletePopup, setShowDeletePopup] = useState(false);

    const openDeletePopup = () => setShowDeletePopup(true);
    const closeDeletePopup = () => setShowDeletePopup(false);

    return {
        showDeletePopup,
        openDeletePopup,
        closeDeletePopup,
    };
};
